import produce from 'immer';
import { SET_CLEAR_CUSTOMER } from 'containers/WorkQueue/constants';
import sortBy from 'lodash/sortBy';
import reverse from 'lodash/reverse';
import { SET_SCORING_DETAILS, SET_STATUS_CODE_TYPES } from './constants';

export const initialState = {
  scoringData: [],
  statusCodeList: [],
};

const reducer = (state = initialState, { type, payload }: any) =>
  produce(state, (draft: any) => {
    switch (type) {
      case SET_SCORING_DETAILS:
        draft.scoringData = reverse(sortBy(payload.data, ['year']));
        break;
      case SET_CLEAR_CUSTOMER:
        draft.scoringData = initialState.scoringData;
        break;
      case SET_STATUS_CODE_TYPES:
        draft.statusCodeList = payload;
        break;
      default: {
        break;
      }
    }
  });

export default reducer;
